import { Box, Flex, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Fragment } from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import { Section, SectionTitle, Text } from "areas/product/jewlr/components"
import { IS_PORTAL } from "helpers/application"

const SpecName = styled(Typography).attrs((props) => ({
  as: "h3",
  fontSize: "16px",
  fontWeight: "500",
  lineHeight: "16px",
  mb: "2px",
  textTransform: "capitalize",
  ...props,
}))``

const Description = styled(Text).attrs((props) => ({
  flexBasis: { _: "auto", desktop: props.portal ? "65%" : "556px" },
  ...props,
}))``

const InternalProductDescription = ({ description, specs, styleCode }) => {
  return (
    <Section
      id="product-description"
      pb={3}
      pt={{ tablet: 6 }}
      px={{ _: 2, desktop: 4 }}
    >
      <SectionTitle
        mb={{ _: "18px", desktop: "10px" }}
        textAlign={{ _: "center", desktop: "left" }}
      >
        DESCRIPTION & DETAILS
      </SectionTitle>

      <Flex
        flexDirection={{ _: "column", desktop: "row" }}
        gap={{ _: "28px", desktop: 5 }}
      >
        {description && (
          <Description portal={IS_PORTAL()}>
            {description.split("\n").map((line, i) => (
              <Fragment key={`reg-product-${i}`}>
                {line} <br />
              </Fragment>
            ))}
          </Description>
        )}
        <Box display="grid" flex="1" gap="18px" gridTemplateColumns="1fr 1fr">
          {specs.map((spec, i) => (
            <Box key={`spec${spec.name}${i}`}>
              {spec.component_label && <span>{spec.component_label}</span>}
              <SpecName>{spec.name}:</SpecName>
              <Text
                dangerouslySetInnerHTML={{
                  __html: spec.value.replace(/\n/g, "<br/>"),
                }}
              />
            </Box>
          ))}
          <Box>
            <SpecName>Style Code:</SpecName>
            <Text>{styleCode}</Text>
          </Box>
        </Box>
      </Flex>
    </Section>
  )
}

// REFACTOR TODO: should be done in back-end
const stone_spec_string = (wizard_option, selected_value) => {
  var out = wizard_option.stone_size
  if (
    (selected_value == "04DIAM" || selected_value == "04LABDIAM") &&
    wizard_option.diamond_weight
  ) {
    out += ` (${wizard_option.diamond_weight.toFixed(2)} ct tw)`
  }
  return out
}
const specs = (state) => {
  let specs_array = []

  // Add spec for each stone
  Object.keys(state.wizard.data).forEach((pref) => {
    if (
      state.wizard.data[pref].stone_size &&
      state.wizard.data[pref].heading.title &&
      !state.wizard.data[pref].hide_on_pdp_description
    ) {
      let selected_value =
        state.choices && state.choices[pref] ? state.choices[pref].value : null
      specs_array.push({
        name: state.wizard.data[pref].heading.title,
        value: stone_spec_string(state.wizard.data[pref], selected_value),
      })
    }
  })
  specs_array.push(...(state.wizard.description.specs || []))

  // Add extra specs
  Object.keys(state.choices).forEach((pref) => {
    // not show duplicate spec etc JWL0690
    if ((pref = "face1" || pref == "face2")) {
      return
    }
    let specs = state.choices[pref].specs
    if (specs) {
      specs.forEach((spec) => {
        let spec_data = { name: spec.name, value: spec.value }
        if (
          state.wizard.description.has_face_component_options &&
          state.wizard.data[pref]
        ) {
          Object.assign(spec_data, {
            component_label: state.wizard.data[pref].display_label,
          })
        }
        specs_array.push(spec_data)
      })
    }
  })
  return specs_array
}

const mapStateToProps = (state) => {
  return {
    description: state.wizard.description.product_description,
    details: state.wizard.description,
    specs: specs(state),
    styleCode: state.choices?.style_code?.value,
  }
}

const mapDispatchToProps = () => {
  return {}
}

InternalProductDescription.propTypes = {
  description: PropTypes.string,
  details: PropTypes.object,
  specs: PropTypes.array,
  styleCode: PropTypes.string,
}

const ProductDescription = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalProductDescription)

export default ProductDescription
